var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4969 20.3088V12.7929L23.507 10.1988V5.82788L17.1283 3.53582V0H8.36867V3.53582L1.99001 5.82788V10.1988L0 12.7929V20.3088L1.99001 22.9916L0 29.1749L12.7574 32L25.4969 29.1749L23.507 22.9916L25.4969 20.3088Z",
    fill: "#FFF200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7756 22.9917C16.2937 22.9917 19.1543 20.1311 19.1543 16.6131C19.1543 13.095 16.2937 10.2344 12.7756 10.2344C9.2576 10.2344 6.39697 13.0772 6.39697 16.6131C6.39697 20.1488 9.23984 22.9917 12.7756 22.9917Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4969 20.3088V12.7929L23.507 10.1988V5.82788L17.1283 3.53582V0H8.36867V3.53582L1.99001 5.82788V10.1988L0 12.7929V20.3088L1.99001 22.9916L0 29.1749L12.7574 32L25.4969 29.1749L23.507 22.9916L25.4969 20.3088Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7756 22.9917C16.2937 22.9917 19.1543 20.1311 19.1543 16.6131C19.1543 13.095 16.2937 10.2344 12.7756 10.2344C9.2576 10.2344 6.39697 13.0772 6.39697 16.6131C6.39697 20.1488 9.23984 22.9917 12.7756 22.9917Z",
    fill: "#FFF200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDark);
export default __webpack_public_path__ + "static/media/icon-dark.c91b14952e53cc652db67b126a9dd475.svg";
export { ForwardRef as ReactComponent };